module.exports = __webpack_public_path__ + "img/icon_001.861b122.webp";